import { Link } from "react-router-dom";

function Footer() {

  return (
    <footer className=" h-12 text-sm w-[95%] lg:w-full mx-auto">
      <div className="flex justify-between mx-auto lg:w-4/6">
      <div className="ml-1 my-auto hover:opacity-80 ">
        <Link to="/disclaimer">
          © {new Date().getFullYear()} BM-Campus
        </Link>
      </div>

      <ul className="flex my-auto">
        <li className="mr-2 lg:mr-6 hover:opacity-80">
          <Link to="/ ">Home</Link>
        </li>
        
        <li className="mr-2 lg:mr-6 hover:opacity-80 ">
          <Link to="/disclaimer">Disclaimer</Link>
        </li>
      </ul>
      </div>
    </footer>
  );
}

export default Footer;
